import { render } from "./settled.vue?vue&type=template&id=2b11b547&scoped=true"
import script from "./settled.vue?vue&type=script&lang=js"
export * from "./settled.vue?vue&type=script&lang=js"

import "./settled.vue?vue&type=style&index=0&id=2b11b547&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b11b547"]])

export default __exports__